import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Lock } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
import { CTAButton } from './CTAButton';
const valueStack = [{
  label: '+600 Planos Metálicos con medidas exactas',
  price: '$49.99'
}, {
  label: 'Bono #1: Checklist CERO ERROR',
  price: '$9.99'
}, {
  label: 'Bono #2: Ruta Express 7 Días',
  price: '$14.99'
}, {
  label: 'Bono #3: Planos de Trailers y Gym',
  price: '$19.99'
}, {
  label: 'Bono #4: Aprende a Soldar',
  price: '$14.99'
}, {
  label: 'Bono #5: Presupuesto y Ventas',
  price: '$19.99'
}, {
  label: 'Bono #6: Torneria Desde Cero',
  price: '$12.99'
}, {
  label: 'Bono #7: Herrería Artística',
  price: '$14.99'
}, {
  label: 'Bono #8: Carpintería Que Vende',
  price: '$19.99'
}];
export function PricingSection() {
  return <section id="resumen-oferta" className="py-8 px-4 bg-[#0d0d0d] relative" data-id="element-141">
      <div className="max-w-3xl mx-auto" data-id="element-142">
        {/* Intro */}
        <div className="text-center mb-6" data-id="element-143">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-144">
            ¿CUÁNTO CUESTA{' '}
            <span className="text-[#FF6B00] underline decoration-4 decoration-[#FF6B00]/30 underline-offset-4" data-id="element-145">
              TODO ESTO?
            </span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-base leading-relaxed mb-3" data-id="element-146">
            Cuando los cursos online cobran{' '}
            <span className="text-white font-bold" data-id="element-147">$200 o $500</span> por
            enseñarte solo TEORÍA sin un solo plano utilizable... es natural
            pensar que un paquete con +600 planos y 8 bonos será impagable.
          </p>
          <p className="text-white font-bold text-lg" data-id="element-148">
            Sin embargo,{' '}
            <span className="text-[#FF6B00] uppercase" data-id="element-149">¡NO lo es!</span> Lo
            correcto era hacerlo accesible para TODOS, así que estoy ofreciendo
            un descuento especial de lanzamiento por tiempo limitado...
          </p>
        </div>

        {/* Value Stack Card */}
        <motion.div initial={{
        scale: 0.95,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-[#1a1a1a] border-2 border-[#FF6B00] rounded-2xl overflow-hidden shadow-[0_0_50px_rgba(255,107,0,0.15)] relative" data-id="element-150">
          <div className="absolute top-0 right-0 bg-[#EF4444] text-white px-12 py-1 transform rotate-45 translate-x-14 translate-y-8 font-black shadow-lg z-10 text-sm uppercase tracking-widest border border-white/20" data-id="element-151">
            OFERTA
          </div>

          <div className="p-5 md:p-6 border-b border-[#333]" data-id="element-152">
            <div className="mb-4" data-id="element-153">
              <img src="https://cdn.magicpatterns.com/uploads/36y6WSBrnoWDsuX6jHqshM/ChatGPT_Image_11_feb_2026,_04_40_03_p.m..webp" alt="Sistema Maestro de Herrería — Paquete completo de planos, bonos y herramientas" className="w-full h-auto rounded-lg" data-id="element-154" />
            </div>
            <h3 className="text-2xl font-bold text-white text-center mb-4 uppercase tracking-wide" data-id="element-155">
              Todo Lo Que Obtenés:
            </h3>
            <div className="space-y-2" data-id="element-156">
              {valueStack.map((item, i) => <div key={i} className="flex items-center justify-between text-sm md:text-base py-2 border-b border-[#333]/50 last:border-0 border-dashed" data-id="element-157">
                  <div className="flex items-center text-gray-200" data-id="element-158">
                    <Check className="w-5 h-5 text-[#22C55E] mr-3 flex-shrink-0" data-id="element-159" />
                    <span className={i === 0 ? 'font-bold text-white' : ''} data-id="element-160">
                      {item.label}
                    </span>
                  </div>
                  <span className="text-gray-500 line-through text-xs md:text-sm ml-2 flex-shrink-0 font-mono" data-id="element-161">
                    {item.price}
                  </span>
                </div>)}
            </div>
            <div className="flex items-center justify-between mt-4 pt-3 border-t border-[#FF6B00]/30" data-id="element-162">
              <span className="font-bold text-white text-lg" data-id="element-163">Valor Total:</span>
              <span className="text-gray-400 line-through font-bold text-xl decoration-red-500/50 decoration-2" data-id="element-164">
                $177.91 USD
              </span>
            </div>
          </div>

          <div className="p-6 bg-[#222] text-center" data-id="element-165">
            <p className="text-gray-400 text-sm mb-2 font-medium uppercase tracking-wide" data-id="element-166">
              Hoy accedés por un pago único de:
            </p>
            <div className="mb-4" data-id="element-167">
              <PriceDisplay amount={16.99} className="text-6xl md:text-8xl font-black text-[#FF6B00] tracking-tighter drop-shadow-lg" data-id="element-168" />
            </div>

            <CTAButton size="xl" className="w-full md:w-auto shadow-xl mb-3 text-xl" href="https://carlosponte.com/cart/add?id=56937498575173&quantity=1" data-id="element-169">
              AGREGAR AL CARRITO
            </CTAButton>
            <p className="text-sm text-gray-400 mb-3 font-medium" data-id="element-170">
              Acceso Inmediato a +600 Planos + 8 Bonos &gt;&gt;
            </p>
            <div className="flex flex-col gap-1 items-center justify-center" data-id="element-171">
              <p className="text-xs text-gray-400 font-bold bg-[#111] px-3 py-1 rounded-full border border-[#333] inline-block" data-id="element-172">
                <Lock className="w-3 h-3 inline mr-1 mb-0.5" data-id="element-173" />
                Pago único. SIN cargos mensuales. SIN costos ocultos.
              </p>
              <p className="text-xs text-gray-600 mt-2 italic max-w-sm mx-auto" data-id="element-174">
                Me reservo el derecho de cerrar este descuento en cualquier
                momento después del 15 de febrero de 2026.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Urgency text */}
        <p className="text-gray-400 text-sm text-center mt-5 max-w-xl mx-auto italic" data-id="element-175">
          Eso es toda una vida de proyectos de herrería al alcance de tu mano
          por el precio de un almuerzo.{' '}
          <span className="text-[#EF4444] font-bold not-italic" data-id="element-176">
            Pero esta oferta cerrará pronto
          </span>{' '}
          y no vas a poder entrar a este precio después.
        </p>

        {/* Guarantee */}
        <div className="mt-8" data-id="element-177">
          <h3 className="text-xl md:text-3xl font-bold text-white text-center mb-3" data-id="element-178">
            No Digas "Sí". Solo Decí "Quizás" &{' '}
            <span className="text-[#22C55E] underline decoration-[#22C55E]/30" data-id="element-179">
              Probalo SIN RIESGO
            </span>
          </h3>
          <p className="text-gray-400 text-sm text-center mb-4" data-id="element-180">
            No te voy a dar una "garantía" vacía. Te hago una promesa personal:
          </p>
          <div className="p-5 border border-[#333] rounded-xl bg-[#111] flex flex-col md:flex-row gap-4 items-center shadow-lg" data-id="element-181">
            <ShieldCheck className="w-20 h-20 text-[#FF6B00] flex-shrink-0 drop-shadow-[0_0_15px_rgba(255,107,0,0.3)]" data-id="element-182" />
            <div data-id="element-183">
              <h4 className="text-xl font-bold text-white mb-2" data-id="element-184">
                🛡️ Garantía de 120 Días: "ÁMALO O DÉJALO" —
              </h4>
              <p className="text-gray-400 text-base leading-relaxed" data-id="element-185">
                Si este no es el recurso de herrería más completo que hayas
                visto, escribíme y{' '}
                <span className="text-white font-bold" data-id="element-186">
                  te devuelvo el 100% de tu dinero.
                </span>{' '}
                Sin preguntas. Sin letra pequeña. Sin condiciones. El riesgo es{' '}
                <span className="text-white font-bold underline decoration-[#FF6B00]" data-id="element-187">
                  CERO
                </span>{' '}
                para vos.
              </p>
            </div>
          </div>
        </div>

        {/* Decision / Final CTA */}
        <div className="mt-8 text-center space-y-4" data-id="element-188">
          <p className="text-white font-bold text-xl" data-id="element-189">
            Tenés una decisión que tomar. Y creo que es fácil.
          </p>
          <p className="text-gray-400 text-base max-w-xl mx-auto leading-relaxed" data-id="element-190">
            Por el precio de un café con postre, eliminás{' '}
            <span className="text-white font-bold" data-id="element-191">
              TODOS los dolores de cabeza
            </span>{' '}
            de fabricar muebles profesionales — PARA SIEMPRE. Después de ordenar
            obtenés{' '}
            <span className="text-[#FF6B00] font-bold" data-id="element-192">ACCESO INMEDIATO.</span>{' '}
            Sin esperar envíos. Podés empezar tu primer proyecto en minutos.
          </p>

          <CTAButton size="xl" className="w-full md:w-auto shadow-xl" href="https://carlosponte.com/cart/add?id=56937498575173&quantity=1" data-id="element-193">
            AGREGAR AL CARRITO
          </CTAButton>
          <p className="text-xs text-gray-500" data-id="element-194">
            Pago único. Me reservo el derecho de cerrar este descuento después
            del 25 de febrero de 2026.
          </p>

          {/* P.D. */}
          <div className="text-left bg-[#1a1a1a] p-5 rounded-lg border border-[#333] mt-5 space-y-3 text-sm text-gray-400 shadow-inner" data-id="element-195">
            <p data-id="element-196">
              <span className="text-white font-bold bg-[#333] px-1 rounded mr-1" data-id="element-197">
                P.D:
              </span>{' '}
              Recordá: tenés mi{' '}
              <span className="text-white font-bold" data-id="element-198">
                Garantía 100% Libre de Riesgo.
              </span>{' '}
              Estoy 110% seguro de que vas a estar más contento que un niño en
              Navidad con tus planos. Pero si no, tu inversión está garantizada
              por 7 días completos.
            </p>
            <p data-id="element-199">
              <span className="text-[#EF4444] font-bold bg-[#EF4444]/10 px-1 rounded mr-1" data-id="element-200">
                P.P.D:
              </span>{' '}
              ¡OFERTA SENSIBLE AL TIEMPO! No vas a tener la oportunidad de
              invertir en este paquete a este precio una vez que termine.{' '}
              <span className="text-white font-bold underline decoration-[#EF4444]" data-id="element-201">
                El precio sube a $49.99 y será permanente.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}